import { APP_INITIALIZER, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { of } from 'rxjs';

import { EcmDashboardRoutes } from '@ecm/dashboard';
import { MaterialSpinnerComponent } from '@ecm/material';
import {
    AuthGuard,
    ChatbotNavigationService,
    DeepLinkGuard,
    EcmRouterRoutes,
    PhygitalGuard,
    RouteType,
} from '@ecm/router';

import { AliasesRoutes, LazyRoutes } from './routes';

@NgModule({
    imports: [
        RouterModule.forRoot(
            [
                {
                    path: '',
                    pathMatch: 'full',
                    redirectTo: 'accueil',
                },
                {
                    path: 'boutique/mobile',
                    component: MaterialSpinnerComponent,
                    canActivate: [PhygitalGuard],
                    data: {
                        type: RouteType.VISITOR,
                    },
                },
                {
                    path: 'link/:code',
                    canActivate: [AuthGuard],
                    children: [
                        {
                            path: '',
                            component: MaterialSpinnerComponent,
                            canActivate: [DeepLinkGuard],
                        },
                    ],
                },
            ],
            {},
        ),
        RouterModule.forRoot(AliasesRoutes, {}),
        RouterModule.forRoot(LazyRoutes, {
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled',
            onSameUrlNavigation: 'reload',
            scrollOffset: [0, 80],
        }),
        RouterModule.forRoot(EcmDashboardRoutes, {}),
        RouterModule.forRoot(EcmRouterRoutes, {}),
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: (chatbotNavigationService: ChatbotNavigationService) => {
                return () => {
                    return of(chatbotNavigationService.initBotmanListener());
                };
            },
            deps: [ChatbotNavigationService],
            multi: true,
        },
    ],
    exports: [RouterModule],
})
export class DefaultRoutingModule {}
